<template>
  <div class="page-left">
    <div class="left-top">主体公示</div>
    <div>
      <div
        class="left-item"
        v-for="item in zList"
        :key="item.code"
        :class="{ active: type === item.code }"
        @click="jumpPage(item.url)"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="left-top mg-t20">排行榜</div>
    <div>
      <div
        class="left-item"
        v-for="item in tList"
        :key="item.code"
        :class="{ active: type === item.code }"
        @click="jumpPage(item.url)"
      >
        {{ item.title }}
      </div>
    </div>

    <div class="left-top mg-t20">信用档案</div>
    <div>
      <div
        class="left-item"
        v-for="item in dList"
        :key="item.code"
        :class="{ active: type === item.code }"
        @click="jumpPage(item.url)"
      >
        {{ item.title }}
      </div>
    </div>

    <div class="left-top mg-t20">服务评价</div>
    <div>
      <div
        class="left-item"
        v-for="item in remarkList"
        :key="item.code"
        :class="{ active: type === item.code }"
        @click="jumpPage(item.url)"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "listLift",
  props: ["type"],
  data() {
    return {
      zList: [
        {
          title: "经纪机构公示",
          code: "jggs",
          url: "/company/list",
        },
        {
          title: "经纪从业人员公示",
          code: "cygs",
          url: "/person/list",
        },
         {
          title: "门店公示",
          code: "store",
          url: "/store/list",
        },
        
        {
          title: "网签地点分布",
          code: "wqdd",
          url: "/company/map",
        },
     
      ],
      tList: [
         {
          title: "挂牌房源公示",
          code: "resourcesList",
          url: "/resources/list",
        },
        {
          title: "累计销售",
          code: "salesList",
          url: "/resources/salesList",
        },
        // {
        //   title: "机构签约量排行",
        //   code: "qzTop",
        //   url: "/company/agenSort",
        // },
        // {
        //   title: "机构挂牌量排行",
        //   code: "listing",
        //   url: "/company/listingSort",
        // },        
      ],
      dList: [
       {
          title: "经纪机构信用档案",
          code: "jgda",
          url: "/credit/list",
        },
        {
          title: "经纪机构良好信息",
          code: "jgGood",
          url: "/company/good",
        },
           {
          title: "经纪机构不良信息",
          code: "jgBad",
          url: "/company/bad",
        },
        {
          title: "经纪从业人员信用档案",
          code: "jgryda",
          url: "/credit/personList",
        },
          {
          title: "经纪及从业人员良好信息",
          code: "personGood",
          url: "/person/good",
        },
           {
          title: "经纪及从业人员不良信息",
          code: "personBad",
          url: "/person/bad",
        },
      ],
      remarkList: [
        {
          title: "机构公众评价",
          code: "comRemark",
          url: "/remark/companyList",
        },
        {
          title: "人员公众评价",
          code: "perRemark",
          url: "/remark/personList",
        },        
      ]
    };
  },
  methods: {
    jumpPage(url) {
      this.$router.push(url)
      // const jumpUrl = this.$router.resolve({ path: url });
      // window.open(jumpUrl.href, "_blank");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.page-left {
  width: 250px;
  margin-right: 30px;
  margin-bottom: 42px;
  .left-top {
    width: 100%;
    height: 42px;
    padding-left: 10px;
    color: #000;
    font-size: 16px;
    line-height: 42px;
    background: #f6f7f8;
  }
  .left-item {
    width: 100%;
    height: 52px;
    padding-left: 10px;
    font-size: 16px;
    line-height: 52px;
    color: #777;
    border: 1px solid #eee;
    border-top: none;
    cursor: pointer;
    &:last-child {
      border-bottom: 1px solid #b1191a;
    }
    &:hover {
      color: #b1191a;
    }
  }
  .active {
    color: #b1191a;
  }
}
</style>
